import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import MuiAlert from '@material-ui/lab/Alert'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconInfo } from 'assets/icons/info.svg'
import useStyles from './styles'

const Alert = props => {
  const { extraClass, children, severity } = props
  const classes = useStyles()

  return (
    <MuiAlert
      className={clsx(classes.root, extraClass)}
      icon={<SvgIcon component={IconInfo} className={classes.icon} />}
      severity={severity}
    >
      {children}
    </MuiAlert>
  )
}

Alert.propTypes = {
  severity: PropTypes.string,
  children: PropTypes.node,
}

export default Alert
